import { render, staticRenderFns } from "./addCostDetails.vue?vue&type=template&id=12b14a3c&scoped=true"
import script from "./addCostDetails.vue?vue&type=script&lang=js"
export * from "./addCostDetails.vue?vue&type=script&lang=js"
import style0 from "./addCostDetails.vue?vue&type=style&index=0&id=12b14a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b14a3c",
  null
  
)

export default component.exports